













import {Component, Prop, Vue} from 'vue-property-decorator';
import {User} from '@/oauth/User';
import AuthorityControl from '@/oauth/AuthorityControl.vue';
import {UserDto} from '@/oauth/UserDto';

@Component({
  components: {AuthorityControl},
})
export default class UserControl extends Vue {
  @Prop({default: () => new User()}) private user!: User;
  private loading = false;

  private async postUser() {
    this.loading = true;
    try {
      await UserDto.save(this.user);
      this.$q.notify({message: '成功'});
      this.$root.$emit('UserAdded');
    } catch (e: any) {
      this.$q.notify({message: e.toString(), color: 'red'});
    }
    this.loading = false;
  }
}
